import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from './core/auth/auth.service';
import {
  loggingOut$,
  setMobile,
  userAuthenticated$,
} from './core/state/user/user.store';
import { Router } from '@angular/router';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();

  constructor(
    private authService: AuthService,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {
    // detect screen size changes
    this.breakpointObserver
      .observe(['(max-width: 650px)'])
      .subscribe((result: BreakpointState) => {
        setMobile(result.matches);
      });
  }

  ngOnInit() {
    this.authService.checkSession();
    this.subscriptions.add(
      this.loggingOut$.subscribe((x) => {
        this.showForce = false;
        if (x === true) {
          setTimeout(() => {
            this.showForce = true;
          }, 60000);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  public authenticated$: Observable<boolean> = userAuthenticated$;
  public loggingOut$: Observable<boolean> = loggingOut$;
  public showForce = false;

  public forceLogout() {
    this.showForce = false;
    this.authService.forceLogout();
  }
}
